export default __webpack_public_path__ + "static/media/IMG_1980.0aeb2f37.JPG";